module.exports = __webpack_public_path__ + "img/portrait-041.b99f8b28.jpg";